import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  string, shape, func, any, bool,
} from 'prop-types';
import { Affix, Button, Spin } from 'antd';
import { Box, Flex, Text } from '../../../shared/components';
import {
  guardarEncargos,
  inicializarCreadorEncargos,
} from '../../../../state/actions/creators/encargos.creador.actioncreator';
import { handleSagaStatus, obtenerEstadoRequestDesdeSaga } from '../../../../helpers/sagaStatus.helper';
import CargandoCreadorEncargos from '../../components/skeletons/CargandoCreadorEncargos.skeleton';
import EncargoCard from '../../components/dataEntry/EncargoCard.dataentry';
import { encargosCreacionTypes } from '../../types/encargo.creacion.types';
import Page from '../../../shared/components/layout/Page.layout';
import BuscarPacienteModal from '../../components/modal/BuscarPaciente.modal';
import FooterCrearEncargo from '../../containers/FooterCrearEncargo';

class EncargosCrearPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      encargoUUIDSeleccionado: null,
    };
    this.modalRef = React.createRef();
  }

  componentDidMount() {
    const {
      inicializarCreadorEncargos, match, inicializado, encargos,
    } = this.props;

    if (match) {
      const { params } = match;
      const { promocionId, encargoUUID } = params;
      const encargoPreexistente = encargos.find(e => e.uuid === encargoUUID);
      if (!inicializado) {
        inicializarCreadorEncargos({ promocionId, uuid: encargoUUID });
      }
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {
      inicializarCreadorEncargos, match, inicializado, encargos,
    } = nextProps;
    const {
      match: matchPrevio,
    } = this.props;

    if (match) {
      const { params } = match;
      const { promocionId, encargoUUID } = params;
      if(encargoUUID === matchPrevio.params.encargoUUID) return;
      const encargoPreexistente = encargos.find(e => e.uuid === encargoUUID);
      if (!encargoPreexistente) {
        inicializarCreadorEncargos({ promocionId, uuid: encargoUUID });
      }
    }
  }

  abrirModalSeleccionClienteParaEncargo({ encargoUUID }) {
    this.setState({ encargoUUIDSeleccionado: encargoUUID });
    this.modalRef.current.show();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { estadoPeticionGuardar: previousEstadoPeticionGuardar } = prevProps;
    const { estadoPeticionGuardar } = this.props;
    const { history } = this.props;

    handleSagaStatus({
      estadoPeticion: estadoPeticionGuardar,
      previousEstadoPeticion: previousEstadoPeticionGuardar,
      onWasRunningAndHasSucceded: () => {
        const { response } = estadoPeticionGuardar;
        if (response) {
          const { id, tienda } = response;
          history.replace(`/encargos/${id}/tienda/${tienda}/mostrar`);
        }
      },
    });
  }

  renderEncargos() {
    const { encargos } = this.props;
    return encargos.map(encargo => (
      <Box key={encargo.uuid} mb="16">
        <EncargoCard
          modo="crear"
          onClickSeleccionarCliente={(encargoUUID) => {
            this.abrirModalSeleccionClienteParaEncargo({ encargoUUID });
          }}
          encargo={encargo}
        />
      </Box>
    ));
  }

  render() {
    const { estadoPeticionInicializar, estadoPeticionGuardar } = this.props;
    const { running: peticionInicializarEnCurso } = estadoPeticionInicializar;
    const { running: peticionGuardarEnCurso } = estadoPeticionGuardar;

    const cargandoEncargos = peticionInicializarEnCurso !== false;
    if (cargandoEncargos) {
      return (
        <Box p="32">
          <CargandoCreadorEncargos />
        </Box>
      );
    }

    const { titulo, history, guardarEncargos, encargos } = this.props;
    const { encargoUUIDSeleccionado } = this.state;

    return (
      <Flex height="100%" flexDirection="column" justifyContent="space-between">
        <Spin
          spinning={peticionGuardarEnCurso}
          tip={<Text translationId="encargos.guardando" />}
        >
          <Page
            titulo={titulo}
            navigationItems={[
              {
                node: <Text translationId="navegacion.home" />,
                link: '',
              },
              {
                node: <Text translationId="navegacion.encargos" />,
              },
            ]}
          >
            <BuscarPacienteModal
              width="600px"
              style={{ maxWidth: 1024, top: '5%' }}
              ref={this.modalRef}
              history={history}
              encargoUUID={encargoUUIDSeleccionado}
              vieneDe="crearEncargo"
            />
            <Box>
              { this.renderEncargos() }
            </Box>
            <Box height="72px" />
          </Page>
        </Spin>
        <FooterCrearEncargo visible={encargos[0].detalles.length>0} onClickGuardarEncargo={() => guardarEncargos()} />
      </Flex>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    inicializarCreadorEncargos,
    guardarEncargos,
  }, dispatch);
}

const mapStateToProps = (state) => {
  const { encargosCreador, sagas } = state;
  const {
    titulo, inicializado, encargos, esPresupuesto,
  } = encargosCreador;
  return {
    estadoPeticionInicializar: obtenerEstadoRequestDesdeSaga(sagas, 'ENCARGOS_CREACION_INICIALIZAR'),
    estadoPeticionGuardar: obtenerEstadoRequestDesdeSaga(sagas, 'ENCARGOS_CREACION_GUARDAR'),
    titulo,
    inicializado,
    encargos,
    esPresupuesto,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EncargosCrearPage);

EncargosCrearPage.propTypes = {
  inicializado: bool,
  titulo: string,
  encargos: encargosCreacionTypes,
  estadoPeticionInicializar: shape({
    running: bool,
    success: bool,
  }),
  estadoPeticionGuardar: shape({
    running: bool,
    success: bool,
    response: any,
  }),
  inicializarCreadorEncargos: func.isRequired,
  match: any.isRequired,
};

EncargosCrearPage.defaultProps = {
  titulo: '',
  inicializado: false,
  encargos: [],
  estadoPeticionInicializar: {
    running: false,
    success: null,
  },
  estadoPeticionGuardar: {
    running: false,
    success: null,
    response: null,
  },
};
